import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FaqService } from '../shared/services/faq/faq.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FaqComponent implements OnInit ,OnDestroy {
  categories : any = [];
  selectedTabIndex: any = 0;
  private _unsubscribeAll  : Subject<any> = new Subject<any>();
  constructor(private faqService: FaqService) {
    this.faqService.catList().pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      this.categories = res;
      this.categories.forEach((c, i) => {
        this.faqService.list(c._id).pipe(takeUntil(this._unsubscribeAll)).subscribe(r => {
          this.categories[i].faq = r;
        })
      });
    })
  }

  ngOnInit() {
    
  }

  ngOnDestroy(){
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/faq/faq.component.ts